import { render, staticRenderFns } from "./Dept.vue?vue&type=template&id=01721fdc&scoped=true&"
import script from "./Dept.vue?vue&type=script&lang=js&"
export * from "./Dept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01721fdc",
  null
  
)

export default component.exports